export const SMS_SUBSCRIPTION = {
  SUBSCRIPTION_FOR_APPROVAL: 2,
};
